import { SvgIconProps } from '@traba/types'

const Pause = ({ size, color, strokeWidth, ...props }: SvgIconProps) => {
  return (
    <svg
      className="button"
      viewBox="0 0 60 60"
      width={size}
      height={size}
      {...props}
    >
      <polygon
        points="0,0 15,0 15,60 0,60"
        fill={color}
        strokeWidth={strokeWidth}
      />
      <polygon
        points="25,0 40,0 40,60 25,60"
        fill={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

export default Pause
